export const MAX_FILE_SIZE = 2097152;
export const MAX_FILE_SIZE_TO_CROP = 512;
export const ZIP_MIME_TYPES = [
  'application/zip',
  'application/octet-stream',
  'application/x-zip-compressed',
  'multipart/x-zip'
];
export const IMAGE_MIME_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];
export const MIN_IMAGE_DIMENSION_PX = 256;
export const PDF_MIME_TYPES = ['application/pdf', 'application/wps-office.pdf'];
export const CSV_MIME_TYPES = ['text/csv'];
